/** Canonical Devanagari + English labels for navagrahas (Jyotish UI). */

export const GRAHA_HI_EN_BY_EN = {
  Sun: { hi: 'सूर्य', en: 'Sun' },
  Moon: { hi: 'चंद्र', en: 'Moon' },
  Mars: { hi: 'मंगल', en: 'Mars' },
  Mercury: { hi: 'बुध', en: 'Mercury' },
  Jupiter: { hi: 'गुरु', en: 'Jupiter' },
  Venus: { hi: 'शुक्र', en: 'Venus' },
  Saturn: { hi: 'शनि', en: 'Saturn' },
  Rahu: { hi: 'राहु', en: 'Rahu' },
  Ketu: { hi: 'केतु', en: 'Ketu' },
};

/** Swakshetra / chart rows sometimes use Hindi swami only */
const GRAHA_BY_DEVANAGARI_WORD = {
  सूर्य: GRAHA_HI_EN_BY_EN.Sun,
  चंद्र: GRAHA_HI_EN_BY_EN.Moon,
  चन्द्र: GRAHA_HI_EN_BY_EN.Moon,
  चंद्रमा: GRAHA_HI_EN_BY_EN.Moon,
  मंगल: GRAHA_HI_EN_BY_EN.Mars,
  बुध: GRAHA_HI_EN_BY_EN.Mercury,
  गुरु: GRAHA_HI_EN_BY_EN.Jupiter,
  बृहस्पति: GRAHA_HI_EN_BY_EN.Jupiter,
  शुक्र: GRAHA_HI_EN_BY_EN.Venus,
  शनि: GRAHA_HI_EN_BY_EN.Saturn,
  राहु: GRAHA_HI_EN_BY_EN.Rahu,
  केतु: GRAHA_HI_EN_BY_EN.Ketu,
};

function stripParentheticals(s) {
  return String(s)
    .replace(/\([^)]*\)/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/**
 * Resolve mixed strings: "Sun", "Sun (Surya)", "Mercury (Budh)", "राहु", "मंगल", etc.
 * @returns {{ hi: string, en: string } | null}
 */
export function resolveGrahaLabel(input) {
  if (input == null || input === '') return null;
  if (typeof input === 'object' && input.hi && input.en) {
    return { hi: input.hi, en: input.en };
  }

  const raw = String(input).trim();
  if (GRAHA_BY_DEVANAGARI_WORD[raw]) {
    return GRAHA_BY_DEVANAGARI_WORD[raw];
  }

  const base = stripParentheticals(raw);
  if (GRAHA_HI_EN_BY_EN[base]) {
    return GRAHA_HI_EN_BY_EN[base];
  }

  const lower = base.toLowerCase();
  const tests = [
    [/\bketu\b|केतु|south\s+node/i, 'Ketu'],
    [/\brahu\b|राहु|north\s+node/i, 'Rahu'],
    [/\bshani\b|\bshaani\b|saturn|शनि/i, 'Saturn'],
    [/\bshukra\b|venus|शुक्र/i, 'Venus'],
    [/\b(brihaspati|jupiter|guru)\b|गुरु/i, 'Jupiter'],
    [/\b(budh|budha|mercury)\b|बुध/i, 'Mercury'],
    [/\b(mangal|mars|angaraka)\b|मंगल/i, 'Mars'],
    [/\b(chandra|chander|moon|soma)\b|चंद्र|चन्द्र/i, 'Moon'],
    [/\b(surya|ravi|sun)\b|सूर्य/i, 'Sun'],
  ];

  for (const [re, key] of tests) {
    if (re.test(lower) || re.test(raw)) {
      return GRAHA_HI_EN_BY_EN[key];
    }
  }

  return null;
}

/** Split composite labels e.g. "Sun (Surya), Venus, & Mercury" */
export function splitGrahaPhrase(text) {
  return String(text)
    .split(/\s*,\s*|\s*&\s+|\s+&\s*|\s+and\s+/i)
    .map((s) => s.trim())
    .filter(Boolean);
}
